import { render, staticRenderFns } from "./presupuestoEmergente.vue?vue&type=template&id=8179738a&scoped=true"
import script from "./presupuestoEmergente.vue?vue&type=script&lang=js"
export * from "./presupuestoEmergente.vue?vue&type=script&lang=js"
import style0 from "./presupuestoEmergente.vue?vue&type=style&index=0&id=8179738a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8179738a",
  null
  
)

export default component.exports